<app-info-card
  [iconUrl]="this.getIcon()"
  [title]="this.getTitle()"
  [infoMap]="inofCardData"
  [columns]="getColumns()"
  [solution]="getSolution()"
  [collapsedItems]="4"
>
</app-info-card>
